/**
 * DEV-only Entity Hub fixtures.
 * Enable with ?hubMock=1 (or hubMock=sports|streamer|artist|empty) in DEV builds.
 */

const PORTO_ID = 'mock-fc-porto';
const STREAMER_ID = 'mock-streamer';
const ARTIST_ID = 'mock-artist';
const EMPTY_ID = 'mock-empty';

const sportsHub = {
  entity: {
    id: PORTO_ID,
    name: 'FC Porto',
    type: 'Club',
    category: 'Sports',
    sub_category: 'Club',
    imageUrl: null,
    officialWebsite: 'https://www.fcporto.pt',
    league: 'Liga Portugal',
    competitions: ['Liga Portugal', 'UEFA Champions League', 'Taça de Portugal'],
    country: 'Portugal',
    sport: 'Football',
    hubFamily: 'sports',
  },
  nextEvent: {
    id: 'fx-1',
    kind: 'fixture',
    startsAt: '2026-08-01T19:30:00.000Z',
    venueName: 'Estádio do Dragão',
    venueImageUrl: null,
    title: 'FC Porto vs Sporting CP',
    competition: {
      id: 'comp-liga',
      name: 'Liga Portugal',
      badgeUrl: null,
    },
    home: { entityId: PORTO_ID, name: 'FC Porto', crestUrl: null },
    away: { entityId: 'mock-sporting', name: 'Sporting CP', crestUrl: null },
    broadcastChannels: [
      {
        name: 'Sport TV 1',
        logoUrl: null,
        programmeId: 'mock-epg-1',
        programmeTitle: 'FC Porto vs Sporting CP',
        startsAt: '2026-08-01T19:05:00.000Z',
        endsAt: '2026-08-01T21:10:00.000Z',
        matchSource: 'epg_exact',
      },
    ],
  },
  standingsByCompetition: [
    {
      competitionId: 'comp-liga',
      competitionName: 'Liga Portugal',
      season: '2025/26',
      updatedAt: '2026-07-26T22:00:00.000Z',
      rows: [
        { rank: 1, team: { entityId: PORTO_ID, name: 'Porto', crestUrl: null }, played: 17, won: 16, drawn: 1, lost: 0, points: 49 },
        { rank: 2, team: { entityId: 'mock-sporting', name: 'Sporting', crestUrl: null }, played: 17, won: 13, drawn: 3, lost: 1, points: 42 },
        { rank: 3, team: { entityId: 'mock-benfica', name: 'Benfica', crestUrl: null }, played: 17, won: 11, drawn: 6, lost: 0, points: 39 },
        { rank: 4, team: { entityId: 'mock-braga', name: 'Braga', crestUrl: null }, played: 17, won: 8, drawn: 5, lost: 4, points: 29 },
        { rank: 5, team: { entityId: 'mock-fam', name: 'Famalicão', crestUrl: null }, played: 17, won: 7, drawn: 5, lost: 5, points: 26 },
        { rank: 6, team: { entityId: 'mock-mor', name: 'Moreirense', crestUrl: null }, played: 17, won: 7, drawn: 3, lost: 7, points: 24 },
        { rank: 7, team: { entityId: 'mock-gui', name: 'Guimarães', crestUrl: null }, played: 17, won: 6, drawn: 4, lost: 7, points: 22 },
        { rank: 8, team: { entityId: 'mock-gil', name: 'Gil Vicente', crestUrl: null }, played: 17, won: 6, drawn: 3, lost: 8, points: 21 },
        { rank: 9, team: { entityId: 'mock-est', name: 'Estoril', crestUrl: null }, played: 17, won: 5, drawn: 5, lost: 7, points: 20 },
        { rank: 10, team: { entityId: 'mock-rio', name: 'Rio Ave', crestUrl: null }, played: 17, won: 4, drawn: 7, lost: 6, points: 19 },
        { rank: 11, team: { entityId: 'mock-avs', name: 'AVS', crestUrl: null }, played: 17, won: 4, drawn: 5, lost: 8, points: 17 },
        { rank: 12, team: { entityId: 'mock-cas', name: 'Casa Pia', crestUrl: null }, played: 17, won: 4, drawn: 4, lost: 9, points: 16 },
      ],
    },
    {
      competitionId: 'comp-ucl',
      competitionName: 'Champions League',
      season: '2025/26',
      updatedAt: '2026-07-26T22:00:00.000Z',
      rows: [
        { rank: 1, team: { entityId: 'mock-arsenal', name: 'Arsenal', crestUrl: null }, played: 6, won: 5, drawn: 1, lost: 0, points: 16 },
        { rank: 2, team: { entityId: PORTO_ID, name: 'Porto', crestUrl: null }, played: 6, won: 4, drawn: 1, lost: 1, points: 13 },
        { rank: 3, team: { entityId: 'mock-barca', name: 'Barcelona', crestUrl: null }, played: 6, won: 3, drawn: 2, lost: 1, points: 11 },
        { rank: 4, team: { entityId: 'mock-monaco', name: 'Monaco', crestUrl: null }, played: 6, won: 1, drawn: 1, lost: 4, points: 4 },
      ],
    },
    {
      competitionId: 'comp-taca',
      competitionName: 'Taça de Portugal',
      season: '2025/26',
      updatedAt: '2026-07-26T22:00:00.000Z',
      rows: [
        { rank: null, team: { entityId: PORTO_ID, name: 'Porto', crestUrl: null }, played: 3, won: 3, drawn: 0, lost: 0, points: 'QF' },
        { rank: null, team: { entityId: 'mock-benfica', name: 'Benfica', crestUrl: null }, played: 3, won: 3, drawn: 0, lost: 0, points: 'QF' },
        { rank: null, team: { entityId: 'mock-sporting', name: 'Sporting', crestUrl: null }, played: 2, won: 2, drawn: 0, lost: 0, points: 'QF' },
      ],
    },
  ],
  links: [
    { label: 'Official website', url: 'https://www.fcporto.pt', kind: 'website' },
    { label: 'Instagram', url: 'https://instagram.com/fcporto', kind: 'instagram' },
    { label: 'X', url: 'https://x.com/FCPorto', kind: 'twitter' },
  ],
  streamingPlatforms: [],
  curiosities: [],
  news: [],
  concerts: [],
  hubRenderable: true,
};

const streamerHub = {
  entity: {
    id: STREAMER_ID,
    name: 'Streamer Name',
    type: 'Person',
    category: 'Gaming',
    imageUrl: null,
    hubFamily: 'person',
  },
  nextEvent: null,
  standingsByCompetition: [],
  streamingPlatforms: [
    { key: 'youtube', label: 'YouTube', url: 'https://youtube.com/@demo' },
    { key: 'twitch', label: 'Twitch', url: 'https://twitch.tv/demo' },
    { key: 'kick', label: 'Kick', url: 'https://kick.com/demo' },
  ],
  links: [
    { label: 'Official website', url: 'https://example.com', kind: 'website' },
    { label: 'Discord', url: 'https://discord.gg/demo', kind: 'discord' },
    { label: 'Instagram', url: 'https://instagram.com/demo', kind: 'instagram' },
  ],
  curiosities: [
    { id: 'c1', text: 'Started streaming in 2019; grew from variety to competitive FPS.', source: 'mock', kind: 'curiosity' },
  ],
  news: [
    { id: 'n1', title: 'New merch drop', summary: 'Limited hoodie line ships EU-wide next week.', url: 'https://example.com/merch', publishedAt: '2026-07-20T12:00:00.000Z', sourceName: 'Blog' },
    { id: 'n2', title: 'Collab announced', summary: 'Joint charity stream Saturday.', url: 'https://example.com/collab', publishedAt: '2026-07-22T12:00:00.000Z', sourceName: 'Social' },
  ],
  concerts: [],
  hubRenderable: true,
};

const artistHub = {
  entity: {
    id: ARTIST_ID,
    name: 'Taylor Swift',
    type: 'Person',
    category: 'Music',
    imageUrl: null,
    hubFamily: 'person',
  },
  nextEvent: {
    id: 'c-lisbon',
    kind: 'concert',
    startsAt: '2026-08-12T17:00:00.000Z',
    venueName: 'Estádio da Luz',
    venueImageUrl: null,
    title: 'Eras Tour — Lisbon',
  },
  standingsByCompetition: [],
  streamingPlatforms: [],
  links: [
    { label: 'Official website', url: 'https://www.taylorswift.com', kind: 'website' },
    { label: 'Instagram', url: 'https://instagram.com/taylorswift', kind: 'instagram' },
  ],
  curiosities: [
    { id: 'c1', text: 'First stadium show in Portugal sold out in under an hour.', source: 'mock', kind: 'curiosity' },
  ],
  news: [
    { id: 'n1', title: 'Latest news', summary: 'Surprise acoustic set confirmed for radio broadcast.', url: 'https://example.com/news', publishedAt: '2026-07-18T12:00:00.000Z', sourceName: 'Press' },
  ],
  concerts: [
    {
      id: 'c-lisbon',
      title: 'Eras Tour',
      venueName: 'Estádio da Luz',
      city: 'Lisbon',
      country: 'Portugal',
      startsAt: '2026-08-12T17:00:00.000Z',
      url: 'https://example.com/tickets',
    },
    {
      id: 'c-paris',
      title: 'Eras Tour',
      venueName: 'Accor Arena',
      city: 'Paris',
      country: 'France',
      startsAt: '2026-08-16T18:00:00.000Z',
      url: 'https://example.com/tickets-paris',
    },
  ],
  hubRenderable: true,
};

const emptyHub = {
  entity: {
    id: EMPTY_ID,
    name: 'Unknown',
    hubFamily: 'sports',
  },
  nextEvent: null,
  standingsByCompetition: [],
  links: [],
  streamingPlatforms: [],
  curiosities: [],
  news: [],
  concerts: [],
  hubRenderable: false,
};

const MOCKS_BY_VARIANT = {
  sports: sportsHub,
  streamer: streamerHub,
  artist: artistHub,
  empty: emptyHub,
  '1': sportsHub,
  true: sportsHub,
};

/**
 * @returns {boolean}
 */
export function isHubMockEnabled() {
  if (!import.meta.env.DEV) return false;
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash || '';
    const hashQuery = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : '';
    const hashParams = new URLSearchParams(hashQuery);
    return params.has('hubMock') || hashParams.has('hubMock');
  } catch {
    return false;
  }
}

function readMockVariant() {
  try {
    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash || '';
    const hashQuery = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : '';
    const hashParams = new URLSearchParams(hashQuery);
    const raw = params.get('hubMock') || hashParams.get('hubMock') || 'sports';
    return String(raw).toLowerCase();
  } catch {
    return 'sports';
  }
}

/**
 * @param {string} entityId
 * @returns {object|null}
 */
export function getMockHub(entityId) {
  const variant = readMockVariant();
  if (variant === 'empty' || entityId === EMPTY_ID) {
    return emptyHub;
  }

  let base = MOCKS_BY_VARIANT[variant] || sportsHub;
  if (entityId === STREAMER_ID) base = streamerHub;
  if (entityId === ARTIST_ID) base = artistHub;

  // Clone lightly so highlight works against the live search entityId in DEV.
  const hub = structuredClone(base);
  if (hub.entity) {
    hub.entity.id = entityId || hub.entity.id;
  }
  if (hub.entity?.hubFamily === 'sports' && Array.isArray(hub.standingsByCompetition)) {
    const targetId = entityId || hub.entity.id;
    hub.standingsByCompetition.forEach((table) => {
      (table.rows || []).forEach((row) => {
        if (row.team?.name && /porto/i.test(row.team.name)) {
          row.team.entityId = targetId;
        }
      });
    });
    if (hub.nextEvent?.home && /porto/i.test(hub.nextEvent.home.name || '')) {
      hub.nextEvent.home.entityId = targetId;
    }
  }
  return hub;
}

export const ENTITY_HUB_MOCK_IDS = {
  sports: PORTO_ID,
  streamer: STREAMER_ID,
  artist: ARTIST_ID,
  empty: EMPTY_ID,
};
